/**************************************************
 * Nombre:       Icono_Texto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Avatar, Grid, Typography} from "@mui/material";
import {CheckCircleOutline} from "@mui/icons-material";
import {theme} from "../../../../Tema";


const Icono_Texto = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}

        >

            <Grid container size={{xs: 2, sm: 12, md: 1}} sx={{justifyContent: 'flex-start', mt: -0.5}}>
                <CheckCircleOutline sx={{fill: theme.palette.secondary.main}} />
            </Grid>

            <Grid container size={{xs: 10, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{
                    fontSize: 14,
                    fontWeight: 400,
                    lineHeight: 1.2
                }}>{item}</Typography>
            </Grid>

        </Grid>
    )

}
export default Icono_Texto